import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const projectSettingsServicedeskLanguageKeyRoute: InvariantJiraRoute = {
	name: 'project-settings-servicedesk-language-key',
	path: '/jira/servicedesk/projects/:projectKey/settings/language/:languageKey/:sidebarItemKey?',
};
